@layer module {
.maintenance-modal-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
    }
} // layer module










@layer app {
.maintenance-modal-wrapper .heading {
            margin-bottom: $size-15;
    }

.maintenance-modal-wrapper {
            color: var(--banky-black);
            font-size: var(--font-size-lg);
            font-style: normal;
            font-weight: 400;
            line-height: normal;
    }

.maintenance-modal-wrapper .heading {
            font-size: var(--font-size-xl);
    }
} // layer app
